import Vue from 'vue'
import global_mixin from './global_mixins.js'
import '../css/video_gallery.css'

const app = new Vue({
  el: '#app',
  mixins: [global_mixin],
    data () {
      return {
        slide: 0,
        sliding: false
      }
    },
    methods: {
      onSlideStart (slide) {
        this.sliding = true
        this.stop()
      },
      onSlideEnd (slide) {
        this.sliding = false
      }
    }
})


// WEBPACK FOOTER //
// ./core/vue/js/video_gallery.js